import { render, staticRenderFns } from "./ModalProjectGroupEdit.vue?vue&type=template&id=c8ccdf96&lang=pug"
import script from "./ModalProjectGroupEdit.vue?vue&type=script&lang=js"
export * from "./ModalProjectGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports